import { useSelector } from 'react-redux'
import Preparation from 'src/components/ios-extreme/preparation'
import BasicVerfiy from 'src/components/ios-extreme/basic-verfiy'
import ExtremeVerfiy from 'src/components/ios-extreme/extreme-verfiy'
import Backup from 'src/components/ios-extreme/backup'
import Congratulations from 'src/components/ios-extreme/congratulations'
import { useEffect, useState } from 'react'
import { getAllUserDevice, getNotBindOrder } from 'src/@api/login.js'
import { clearBindOrderContext, ensureBindOrderContext } from 'src/utils/resolveCurrentOrderId'
import { filterValidUnboundOrders, redirectIfShouldBuyPackage } from 'src/utils/chooseDeviceRedirect'
import { messageInfo } from 'src/components/Message'

const IosExtreme = () => {
  const store = useSelector(state => state.Common)
  const [started, setStarted] = useState(false) // 是否确认准备工作，开始初级验证
  const [basicOver, setBasicOver] = useState(false) // 是否为刚完成初级验证，进入高级验证
  const [justVerified, setJustVerified] = useState(false) // 是否为刚完成高级验证，进入Backup
  const [justVerified2, setJustVerified2] = useState(false) // 是否为刚完成Backup，进入Congratulations
  const [setupBlocked, setSetupBlocked] = useState(true)

  const resetAll = () => {
    setStarted(false)
  }


  // 进入页：已绑定且无可绑未绑单 → Dashboard；有效未绑单才继续绑定向导
  useEffect(() => {
    const init = async () => {
      const guard = await ensureBindOrderContext(window.location.search)
      if (guard.blocked) {
        setSetupBlocked(true)

        return
      }

      let devices = []
      try {
        const devicesRes = await getAllUserDevice({}).catch(() => ({ data: [] }))
        devices = Array.isArray(devicesRes?.data) ? devicesRes.data : []
      } catch (err) {
        devices = []
      }

      let result
      try {
        result = await getNotBindOrder()
      } catch (err) {
        messageInfo(err?.message || 'Network error, please try again')

        return
      }

      const unbound = filterValidUnboundOrders(result?.data)
      const orderStillBindable =
        guard.orderId != null && unbound.some(order => String(order.id) === String(guard.orderId))

      // 仅当 URL/缓存 orderId 仍是有效未绑单时，才继续绑定（含加绑第二台）
      if (orderStillBindable) {
        setSetupBlocked(false)

        return
      }

      // 陈旧 orderId（已绑完 / 失效）清掉，避免 F5 卡在绑定页
      if (guard.orderId && !orderStillBindable) {
        clearBindOrderContext()
      }

      // 已有绑定设备且没有可绑未绑单 → Dashboard
      if (devices.length > 0 && unbound.length === 0) {
        window.location.assign('/dashboard')

        return
      }

      // 已有设备但仍有其它未绑单：挂上有效单后继续绑定
      if (devices.length > 0 && unbound.length > 0) {
        setSetupBlocked(false)

        return
      }

      if (await redirectIfShouldBuyPackage(result)) {
        return
      }

      setSetupBlocked(false)
    }
    init()
  }, [])

  if (setupBlocked) return null

  return (
    <>
      <div className='Bxl:h-[calc(var(--vh2)*100-90px)] Bxls:Headers5:h-[calc(var(--vh2)*100-145px)] Header5:big:h-[calc(var(--vh2)*100-210px)] bigs:h-[calc(var(--vh2)*100-270px)]'>
        <div className='w-full h-full flex justify-center pt-[60px] Mlg:pt-[16px] bg-white absolute top-0 left-0 z-[88] overflow-auto' >
          {(!started && !basicOver && !justVerified && !justVerified2) && <Preparation onStart={() => setStarted(true)} />}
          {(started && !basicOver && !justVerified && !justVerified2) && <BasicVerfiy setBasicOver={setBasicOver} goBack={resetAll} />}
          {(basicOver && !justVerified && !justVerified2) && <ExtremeVerfiy setJustVerified={setJustVerified} />}
          {(justVerified && !justVerified2) && <Backup setJustVerified2={setJustVerified2} />}
          {justVerified2 && <Congratulations />}
        </div>
      </div>
    </>
  )
}

export default IosExtreme
